import React from 'react';
import { ASSETS } from '@/lib/api';
import { Crest } from '@/components/Brand';

export default function About() {
  return (
    <div data-testid="about-page" className="bg-white">
      <section className="bg-navy text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 hero-grain opacity-50" />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
          <span className="trj-divider">About TRJ Academy</span>
          <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl mt-6 leading-tight">
            A professional institution for <span className="text-gold font-serif italic">practitioners.</span>
          </h1>
          <p className="mt-6 text-lg text-white/80 max-w-2xl">
            TRJ Academy is the educational division of TRJ Services, Inc. — purpose-built to elevate
            taxation, accounting, and business development training to an institutional standard.
          </p>
        </div>
      </section>

      <section className="py-20 max-w-5xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12">
        <div>
          <h2 className="font-display font-semibold text-3xl text-navy">Mission</h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            To provide professional education and practical training that equips individuals with the
            knowledge, skills, and confidence necessary to advance their careers, businesses, and professional development.
          </p>
        </div>
        <div>
          <h2 className="font-display font-semibold text-3xl text-navy">Vision</h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            To become a nationally recognized academy for professional education, certification, and career advancement.
          </p>
        </div>
      </section>

      <section className="bg-trjlight py-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <img src={ASSETS.student} alt="Founder" loading="lazy" decoding="async" className="rounded-2xl shadow-xl" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <div>
            <span className="trj-divider !text-navy/70 !before:bg-navy/30 !after:bg-navy/30">Founder & Leadership</span>
            <h2 className="font-display font-semibold text-3xl text-navy mt-4">A leadership philosophy rooted in service.</h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              TRJ Academy's leadership team brings decades of combined experience in taxation, accounting,
              and business education. Every program is shaped by senior practitioners committed to mentoring
              the next generation of professionals.
            </p>
            <p className="mt-3 text-slate-600 leading-relaxed">
              Our chancellor oversees the academy's strategic vision, ensuring curriculum integrity, ethical
              standards, and the practical relevance our students depend on.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 max-w-5xl mx-auto px-6 text-center">
        <Crest size="xl" className="mx-auto" />
        <h2 className="font-display font-semibold text-3xl text-navy mt-6">Knowledge • Integrity • Leadership</h2>
        <p className="mt-3 text-slate-600 font-serif italic text-xl">The motto we earn, every day.</p>
      </section>
    </div>
  );
}
